import { Text } from "@oysterhr/ui"
import { useCallback } from "react"
import { usePearlContext } from "../../context/PearlProvider/PearlProvider"
import { type PearlContext } from "../../context/PearlProvider/types"
import { PearlFormAssistantProps } from "./types"

export function PearlFormAssistant<T extends string>({
  elementsForFocusedField,
}: PearlFormAssistantProps<T>) {
  const { focusedField } = usePearlContext<PearlContext<T>>()

  const renderDefault = useCallback(() => {
    if (typeof elementsForFocusedField.default === "string") {
      return <Text>{elementsForFocusedField.default}</Text>
    }
    return elementsForFocusedField.default
  }, [elementsForFocusedField])

  if (!focusedField || !elementsForFocusedField[focusedField]) {
    return renderDefault()
  }

  if (typeof elementsForFocusedField[focusedField] === "string") {
    return <Text>{elementsForFocusedField[focusedField]}</Text>
  }

  return <>{elementsForFocusedField[focusedField]}</>
}
